// extracted by mini-css-extract-plugin
module.exports = {"inner":"inner___17hRz","heading":"heading___3TeWm","action":"action___3mJiO"};